export default "__VITE_ASSET__f67bbf55__"